export const TEAL_300 = '#3DAFA1';
export const TEAL_500 = '#0D9B8A';
export const TEAL_600 = '#0A7C6E';
